module.exports = __webpack_public_path__ + "assets/img/favicons/ms-icon-310x310.png";